module.exports = /******/
function(modules) {
    /******/
    /******/
    // The require function
    /******/
    function __webpack_require__(moduleId) {
        /******/
        /******/
        // Check if module is in cache
        /******/
        if (installedModules[moduleId]) /******/
        return installedModules[moduleId].exports;
        /******/
        /******/
        // Create a new module (and put it into the cache)
        /******/
        var module = installedModules[moduleId] = {
            /******/
            exports: {},
            /******/
            id: moduleId,
            /******/
            loaded: !1
        };
        /******/
        /******/
        // Return the exports of the module
        /******/
        /******/
        /******/
        // Execute the module function
        /******/
        /******/
        /******/
        // Flag the module as loaded
        /******/
        return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), 
        module.loaded = !0, module.exports;
    }
    // webpackBootstrap
    /******/
    // The module cache
    /******/
    var installedModules = {};
    /******/
    /******/
    // Load entry module and return exports
    /******/
    /******/
    /******/
    /******/
    // expose the modules object (__webpack_modules__)
    /******/
    /******/
    /******/
    // expose the module cache
    /******/
    /******/
    /******/
    // __webpack_public_path__
    /******/
    return __webpack_require__.m = modules, __webpack_require__.c = installedModules, 
    __webpack_require__.p = "", __webpack_require__(0);
}([ /* 0 */
/***/
function(module, exports, __webpack_require__) {
    module.exports = __webpack_require__(1);
}, /* 1 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _classCallCheck2 = __webpack_require__(2), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _possibleConstructorReturn2 = __webpack_require__(3), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(4), _inherits3 = _interopRequireDefault(_inherits2), _propTypes = __webpack_require__(5), _propTypes2 = _interopRequireDefault(_propTypes), _react = __webpack_require__(6), _react2 = _interopRequireDefault(_react), _popper = __webpack_require__(7), _popper2 = _interopRequireDefault(_popper), _utilSharedStyles = __webpack_require__(8), _helpers = __webpack_require__(9), Layer = function(_PureComponent) {
        function Layer(props) {
            (0, _classCallCheck3.default)(this, Layer);
            var _this = (0, _possibleConstructorReturn3.default)(this, _PureComponent.call(this, props));
            return _this.extractStyles = function(state) {
                if (state) {
                    var left = Math.round(state.offsets.popper.left), top = Math.round(state.offsets.popper.top);
                    _this.setState({
                        // position: fixed or absolute
                        cssPosition: state.offsets.popper.position,
                        transform: "translate3d(" + left + "px, " + top + "px, 0px)",
                        // state.flipped is either true or undefined
                        flipped: !!state.flipped,
                        actualPosition: state.position,
                        originalPosition: state.originalPosition
                    });
                }
            }, _this.state = {
                position: null,
                transform: null,
                flipped: !1,
                actualPosition: null,
                // We set these default offsets to prevent a flash of popper content in the wrong position
                // which can cause incorrect height calculations. Popper will calculate these values
                offsets: {
                    popper: {
                        left: -9999,
                        top: -9999
                    }
                },
                originalPosition: null,
                // fix Safari parent width: https://product-fabric.atlassian.net/browse/ED-1784
                cssPosition: "absolute"
            }, _this;
        }
        return (0, _inherits3.default)(Layer, _PureComponent), Layer.prototype.componentDidMount = function() {
            this.applyPopper(this.props);
        }, Layer.prototype.componentWillReceiveProps = function(nextProps) {
            this.applyPopper(nextProps);
        }, Layer.prototype.componentDidUpdate = function(prevProps, prevState) {
            prevState.flipped !== this.state.flipped && this.props.onFlippedChange({
                flipped: this.state.flipped,
                actualPosition: this.state.actualPosition,
                originalPosition: this.state.originalPosition
            });
        }, Layer.prototype.componentWillUnmount = function() {
            this.popper && this.popper.destroy();
        }, Layer.prototype.applyPopper = function(props) {
            if (this.targetRef && this.contentRef && (this.popper && this.popper.destroy(), 
            props.content)) // "new Popper(...)" operation is very expensive when called on virtual DOM.
            // This condition reduces the number of calls so we can run our tests faster
            // (time was reduced from 100s to 13s).
            {
                // we wrap our target in a div so that we can safely get a reference to it, but we pass the
                // actual target to popper
                var actualTarget = this.targetRef.firstChild, popperOpts = {
                    placement: (0, _helpers.positionPropToPopperPosition)(props.position),
                    onCreate: this.extractStyles,
                    onUpdate: this.extractStyles,
                    modifiers: {
                        applyStyle: {
                            enabled: !1
                        },
                        hide: {
                            enabled: !1
                        },
                        offset: {
                            enabled: !0,
                            offset: this.props.offset
                        },
                        flip: {
                            enabled: !!this.props.autoFlip,
                            flipVariations: !0,
                            boundariesElement: this.props.boundariesElement,
                            padding: 0
                        },
                        preventOverflow: {
                            enabled: !!this.props.autoFlip,
                            escapeWithReference: !0
                        }
                    }
                }, flipBehavior = (0, _helpers.getFlipBehavior)(props);
                flipBehavior && (popperOpts.modifiers.flip.behavior = flipBehavior), this.popper = new _popper2.default(actualTarget, this.contentRef, popperOpts);
            }
        }, Layer.prototype.render = function() {
            var _this2 = this, _state = this.state, cssPosition = _state.cssPosition, transform = _state.transform;
            return _react2.default.createElement("div", null, _react2.default.createElement("div", {
                ref: function(_ref) {
                    return _this2.targetRef = _ref;
                }
            }, this.props.children), _react2.default.createElement("div", {
                ref: function(_ref2) {
                    return _this2.contentRef = _ref2;
                },
                style: {
                    top: 0,
                    left: 0,
                    position: cssPosition,
                    transform: transform,
                    zIndex: _utilSharedStyles.akZIndexLayer
                }
            }, this.props.content));
        }, Layer;
    }(_react.PureComponent);
    /* eslint-enable react/no-unused-prop-types */
    // I am disabling eslint in the line below because we have an unexplained, unreproducible issue in
    // CI sometimes where popper is not always resolvable. See AK-2971.
    Layer.propTypes = {
        position: _propTypes2.default.oneOf(_helpers.POSITION_ATTRIBUTE_ENUM.values),
        autoFlip: _propTypes2.default.oneOfType([ _propTypes2.default.bool, _propTypes2.default.arrayOf(_propTypes2.default.oneOf([ "top", "right", "bottom", "left" ])) ]),
        boundariesElement: _propTypes2.default.oneOf([ "viewport", "window", "scrollParent" ]),
        offset: _propTypes2.default.string,
        content: _propTypes2.default.node,
        onFlippedChange: _propTypes2.default.func,
        children: _propTypes2.default.node
    }, Layer.defaultProps = {
        position: _helpers.POSITION_ATTRIBUTE_ENUM.default,
        boundariesElement: "viewport",
        autoFlip: !0,
        offset: "0 0",
        content: null,
        onFlippedChange: function() {},
        children: null
    }, exports.default = Layer;
}, /* 2 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/classCallCheck");
}, /* 3 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/possibleConstructorReturn");
}, /* 4 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/inherits");
}, /* 5 */
/***/
function(module, exports) {
    module.exports = require("prop-types");
}, /* 6 */
/***/
function(module, exports) {
    module.exports = require("react");
}, /* 7 */
/***/
function(module, exports) {
    module.exports = require("popper.js");
}, /* 8 */
/***/
function(module, exports) {
    module.exports = require("@atlaskit/util-shared-styles");
}, /* 9 */
/***/
function(module, exports) {
    "use strict";
    function positionToPopper(position) {
        return positionMap[position] ? positionMap[position].position : null;
    }
    /* Convert the autoFlip property into the array format that Popper expects.
	 * The first item must not include the edge-position variation, or Popper will not understand it.
	 */
    function getFlipBehavior(props) {
        return Array.isArray(props.autoFlip) ? [ props.position.split(" ")[0] ].concat(props.autoFlip) : null;
    }
    function positionPropToPopperPosition(position) {
        return positionToPopper(position) || positionMap[POSITION_ATTRIBUTE_ENUM.default].position;
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var positionMap = {
        "top left": {
            position: "top-start",
            animation: "top"
        },
        "top center": {
            position: "top",
            animation: "top"
        },
        "top right": {
            position: "top-end",
            animation: "top"
        },
        "right top": {
            position: "right-start",
            animation: "right"
        },
        "right middle": {
            position: "right",
            animation: "right"
        },
        "right bottom": {
            position: "right-end",
            animation: "right"
        },
        "bottom left": {
            position: "bottom-start",
            animation: "bottom"
        },
        "bottom center": {
            position: "bottom",
            animation: "bottom"
        },
        "bottom right": {
            position: "bottom-end",
            animation: "bottom"
        },
        "left top": {
            position: "left-start",
            animation: "left"
        },
        "left middle": {
            position: "left",
            animation: "left"
        },
        "left bottom": {
            position: "left-end",
            animation: "left"
        }
    }, POSITION_ATTRIBUTE_ENUM = {
        values: [ "top left", "top center", "top right", "right top", "right middle", "right bottom", "bottom left", "bottom center", "bottom right", "left top", "left middle", "left bottom" ],
        default: "right middle"
    };
    exports.getFlipBehavior = getFlipBehavior, exports.positionPropToPopperPosition = positionPropToPopperPosition, 
    exports.POSITION_ATTRIBUTE_ENUM = POSITION_ATTRIBUTE_ENUM;
} ]);


//////////////////
// WEBPACK FOOTER
// ../layer/dist/bundle-cjs.js
// module id = 155
// module chunks = 0